import { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AuthContext } from "../../Auth";
import { updateResumenData } from "../../globalslice";
import getProductInfo from "../../services/productInfo";

const UpdatePriceChangeProfileDealer = () => {
  const resumenData = useSelector((state) => state.global.ResumenData);
  const profile = useSelector((state) => state.profile);
  const currency = useSelector((state) => state.global.currency);
  const tokenRef = useSelector((state) => state.global.tokenRef);
  const slug = useSelector((state) => state.global.slug);
  const { userAuth } = useContext(AuthContext);
  const dispatch = useDispatch();

  // cambio de precio de productos en el carrito
  useEffect(() => {
    // Crear una fuente de CancelToken
    let abortController = null;

    const initUpdate = async () => {
      // filtramos que los productos no sea dominios
      // si el precio del producto agregado se tenga que actualizar, si las banderas de Dealer son diferentes
      const productosToUpdate = await resumenData.filter((item) => {
        return !item.actual && item.type !== "domain" && item.priceDealer !== profile.isDealer;
      });

      // actualización de productos
      await productosToUpdate.forEach(async (item) => {
        abortController = new AbortController();
        const idproduct = item?.product?.id || 0;
        const productInfo = await getProductInfo({ idproduct, currency, tokenRef, slug, token: userAuth?.token }, abortController.signal);
        if (productInfo?.data) {
          let updateData = {
            ...item,
            prices: productInfo.data,
            priceDealer: productInfo.price_dealer,
          };
          let first = true;
          let priceDefault = null,
            priceProduct = null;
          const selectPeriods = await productInfo.data
            .filter((period) => productInfo.Periodicidades || period.Periodo === "12 meses")
            .reduce((acc, period) => {
              const cross = period.DescuentoMostrar ? false : period.Descuento !== period.Precio && period.Descuento !== 0;
              const price = {
                cost: period.Descuento,
                cross_price: cross,
                second_price: period.Precio,
              };

              // guardamos el respaldo del primer registro de precio
              if (first) {
                priceDefault = price;
                first = false;
              }

              // si encontramos el precio seleccionado previamente, lo almacenamos en 'priceProduct'
              if (period.Periodo === item.periodo) {
                priceProduct = price;
              }

              acc[period.Periodo] = price;
              return acc;
            }, {});

          // si no se obtuvo ningún periodo
          if (selectPeriods.length === 0) {
            return;
          }

          // agregamos los periodos
          updateData.selectPeriods = selectPeriods;

          if (priceProduct) {
            updateData.price = priceProduct;
          } else if (priceDefault) {
            updateData.price = priceDefault;
          } else {
            return;
          }

          // actualización de precios del producto
          dispatch(
            updateResumenData({
              id: item.id,
              updates: updateData,
            })
          );
        }
      });
    };

    // se actualiza precios, solo si profile y userAuth son consistes con sesión o sin sesión
    if ((userAuth && profile.name !== "") || (!userAuth && profile.name === "")) {
      initUpdate();
    }

    return () => {
      if (abortController) {
        abortController.abort();
      }
    };
  }, [userAuth, profile.isDealer, dispatch]);

  return null;
};

export default UpdatePriceChangeProfileDealer;
